module.exports = __webpack_public_path__ + "static/media/mobileapp.5aef82df.jpg";